import { Component, OnInit } from '@angular/core';
import { UserDataStoreService } from "../../services/user-data-store.service";
import { AccountTypeEnum } from "../../models/account-type-enum";
import { AccessPolicyEnum, PermissionEnum } from "../../services/guards/permissions";
import { MerchantService } from '../../services/merchant.service';
import { TerminalService } from '../../services/terminal.service';
import { TerminalConfigService } from '../../services/terminal-config.service';
import { CardAcceptorConfigService } from '../../services/card-acceptor-config.service';
import { AppSettingDataService } from '../../services/appsetting-data.service';
import { TimeOutSessionService } from '../../services/time-out-session.service';

@Component({
  selector: 'app-horizontal-nav',
  templateUrl: './horizontal-nav.component.html',
  styleUrls: ['./horizontal-nav.component.scss']
})
export class HorizontalNavComponent implements OnInit {

  public canViewMerchant: boolean;
  public canViewMerchantConfig: boolean;
  public canViewMerchantAudit: boolean;
  public canViewTerminal: boolean;
  public canViewTerminalConfig: boolean;
  public canViewTerminalAudit: boolean;
  public canViewSettlement: boolean;
  public isAdmin: boolean;
  public canViewUsers: boolean;
  public canViewRoles: boolean;
  public canViewClients: boolean;
  public canViewParticipants: boolean;
  public canViewTutukaReports: boolean;
  public canViewMerchantConfigAudit: boolean;
  public canViewTerminalConfigAudit: boolean;
  public canViewReport: boolean;
  public canViewGenericReport: boolean;
  public canViewCredit: boolean;
  public canViewMerchantSignUp: boolean;
  public canEditMerchantSignUp: boolean;
  public canViewTerminalDispatched: boolean;
  public canEditMerchantTerminalConfig: boolean;
  public canViewArchivedTerminals: boolean;
  public canViewTerminalSignUpReport: boolean;
  public canViewReturnedTerminals: boolean;
  public get merchantCount(): number {
    return this._merchantService.count;
  };
  public get terminalCount(): number {
    return this._terminalService.count;
  };
  public get ACSTerminalStagingCount(): string {
    return "(" + this._terminalService.getTerminalSignedUpCount + ")";
  }; 
  public get merchantConfigCount(): number {
    return this._cardAcceptorConfigService.count;
  };
  public get terminalConfigCount(): number {
    return this._terminalConfigService.count;
  };

  constructor(private _userDataStore: UserDataStoreService,
    private _merchantService: MerchantService,
    private _terminalService: TerminalService,
    private _terminalConfigService: TerminalConfigService,
    private _cardAcceptorConfigService: CardAcceptorConfigService,
    private _appSettingDataService: AppSettingDataService,
    private _timeOutSessionService: TimeOutSessionService,
  ) {}

  async ngOnInit() {
    this.canViewMerchant = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewMerchant], [AccessPolicyEnum.ViewMerchant]);
    this.canViewTerminal = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewTerminal], [AccessPolicyEnum.ViewTerminal]);
    this.canViewTerminalConfig = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewTerminalConfiguration], [AccessPolicyEnum.ViewTerminalConfiguration]);
    this.canViewMerchantConfig = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewMerchantConfiguration], [AccessPolicyEnum.ViewMerchantConfiguration]);
    this.canViewMerchantAudit = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewMerchantAudit], [AccessPolicyEnum.ViewMerchantAudit]);
    this.canViewTerminalAudit = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewTerminalAudit], [AccessPolicyEnum.ViewTerminalAudit]);

    this.canViewMerchantConfigAudit = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewMerchantConfigAudit], [AccessPolicyEnum.ViewMerchantConfigAudit]);
    this.canViewTerminalConfigAudit = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewTerminalConfigAudit], [AccessPolicyEnum.ViewTerminalConfigAudit]);

    this.canViewSettlement = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewSettlement], [AccessPolicyEnum.ViewSettlement]);
    this.canViewUsers = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewUser]);
    this.canViewRoles = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewRole], [AccessPolicyEnum.RolesManagement]);
    this.canViewClients = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewClient], [AccessPolicyEnum.ViewClient]);
    this.canViewParticipants = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewParticipantConfiguration], [AccessPolicyEnum.ParticipantManagement]);
    this.canViewTutukaReports = this._userDataStore.hasRequiredPermissions([PermissionEnum.ManageTutukaManagementReportSetups], [AccessPolicyEnum.ManageTutukaManagementReportSetups]);

    this.canViewReport = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewTutukaReport], [AccessPolicyEnum.ViewTutukaReport]);
    this.canViewGenericReport = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewGenericReport], [AccessPolicyEnum.ViewGenericReport]);
    this.canViewCredit = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewCredit], [AccessPolicyEnum.ViewCredit]);
    this.canViewMerchantSignUp = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewMerchantSignUp], [AccessPolicyEnum.ViewMerchantSignUp]);
    this.canEditMerchantSignUp = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditMerchantSignUp], [AccessPolicyEnum.EditMerchantSignUp]);
    this.canViewTerminalDispatched = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewTerminalDispatched], [AccessPolicyEnum.ViewTerminalDispatched]);
    this.canEditMerchantTerminalConfig = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditMerchantTerminalConfig], [AccessPolicyEnum.EditMerchantTerminalConfig]);
    this.canViewArchivedTerminals = this._userDataStore.hasRequiredPermissions([PermissionEnum.ArchiveTerminalTicket], [AccessPolicyEnum.ArchiveTerminalTicket]);
    this.canViewTerminalSignUpReport = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewTerminalSignUpReport], [AccessPolicyEnum.ViewTerminalSignUpReport])
    this.canViewReturnedTerminals = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewReturnedTerminalsReport], [AccessPolicyEnum.ViewReturnedTerminalsReport])
  }

  ngAfterViewInit() {
    this._timeOutSessionService.runSessionTimeOut();
  }

  public get isSystemAdmin() {
    return this._userDataStore.accountType == AccountTypeEnum.SystemAdministrator;
  }
}
